import { render, staticRenderFns } from "./NuevaSalaEspera.vue?vue&type=template&id=12d84b94"
import script from "./NuevaSalaEspera.vue?vue&type=script&lang=js"
export * from "./NuevaSalaEspera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports